// external imports
import React from 'react'
import Helmet from 'react-helmet'
import { H3 } from 'quark-web'
// local imports
import { Text, Header, Carousel } from '~/components'
import styles from './styles'

const Splash = () => (
    <>
        <Header>Lark Seeds International</Header>
        <Text>
            Thank you for visiting Lark Seeds International, a premier vegetable seed breeding
            and production company focused on serving the commercial grower through our dedicated
            network of dealers.
        </Text>
        <Text>
            Our website is in the process of being updated. Please email info@larkseeds.com
        </Text>
    </>
)

export default Splash



// WEBPACK FOOTER //
// ./src/views/Offline/index.js